import { useSearchParams } from 'react-router';

/** "Mine" shows what you created or started; "Everyone" adds what others did. */
export type OwnerMode = 'mine' | 'all';

/** Items owned by `userId` (mode 'mine') or all of them (mode 'all'). */
export function filterByOwner<T>(items: T[], ownerOf: (item: T) => string | null | undefined, userId: string | undefined, mode: OwnerMode): T[] {
  if (mode === 'all') return items;
  return items.filter((item) => !!userId && ownerOf(item) === userId);
}

/** Owner filter kept in the URL (`?show=all`) so links and the back button keep it; defaults to 'mine'. */
export function useOwnerMode(): [OwnerMode, (mode: OwnerMode) => void] {
  const [params, setParams] = useSearchParams();
  const mode: OwnerMode = params.get('show') === 'all' ? 'all' : 'mine';
  const setMode = (next: OwnerMode) =>
    setParams(
      (p) => {
        const n = new URLSearchParams(p);
        if (next === 'all') n.set('show', 'all');
        else n.delete('show');
        return n;
      },
      { replace: true },
    );
  return [mode, setMode];
}
